import React, { Fragment, useState, useEffect } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { affilateDetailsById } from "../../reducers/adminReducers";

const AffiliateUserListDataTable = ({ id, myData, myClass }) => {
  const [data, setData] = useState();
  const dispatch = useDispatch();
  const result = useSelector((state) => state.admin);
  const { affilateDetailList } = result || {};
  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  useEffect(() => {
    setData(myData);
  }, [myData]);

  const userId = selectedUser?._id;

  useEffect(() => {
    if (userId) {
      dispatch(affilateDetailsById(userId));
    }
  }, [dispatch, userId]);

  const columnDefs = [
    {
      name: "Username",
      selector: (row) => row?.username,
      sortable: true,
    },
    {
      name: "Level Name",
      selector: (row) => row?.affiliateLevel?.levelName,
      sortable: true,
    },

    {
      name: "Total Refer",
      selector: (row) => row?.referalCount,
      sortable: true,
    },
    {
      name: "Comission Type",
      selector: (row) => row?.affiliateLevel?.referrerCommissionType,
      sortable: true,
    },
    {
      name: "Comission Percent/Amount",
      selector: (row) => row?.affiliateLevel?.referrerCommission,
      sortable: true,
    },

    {
      name: "Comission Rule",
      selector: (row) => row?.affiliateLevel?.commissionRule,
      sortable: true,
    },

    {
      name: "Action",
      cell: (row) => (
        <Button variant="primary" onClick={() => handleButtonClick(row)}>
          View
        </Button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const handleButtonClick = (row) => {
    setSelectedUser(row); // Set the clicked row data
    setShowModal(true); // Show the modal
  };

  // Handle modal close
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedUser(null);
  };

  return (
    <div>
      <Fragment>
        <DataTableExtensions
          columns={columnDefs}
          data={data}
          print={false}
          export={false}>
          <DataTable
            data={data}
            columns={columnDefs}
            className={myClass}
            pagination
            striped={true}
            center={true}
            selectableRows
            // clearSelectedRows={selectedRows}
            // onSelectedRowsChange={(e) => handleSelectUsers(e)}
          />
        </DataTableExtensions>
      </Fragment>
      {/* <BlockConfirmation
				title={'Delete User'}
				open={open2}
				handleConfirm={handleConfirm}
				onCloseModal={onCloseModal}
				id={activeId}
				blockUnblockInfo={activeUser}
			/> */}

      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>User Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Email</th>
                <th>Username</th>
                <th>Total Deposit</th>
              </tr>
            </thead>
            <tbody>
              {affilateDetailList?.map((el, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{el?.email}</td>
                  <td>{el?.username}</td>
                  <td>{el?.totalDeposit}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

// const ActionButton = ({ row, handleDelete, handleEdit, handleBlock }) => {
// 	return (
// 		<div className="action-btn action_btn_dot">
// 			<Dropdown>
// 				<Dropdown.Toggle variant="success" id="dropdown-basic">
// 					<i
// 						className="fa fa-ellipsis-v"
// 						style={{
// 							width: 35,
// 							fontSize: 20,
// 							padding: 11,
// 							color: '#e4566e',
// 						}}
// 					></i>
// 				</Dropdown.Toggle>
// 				<Dropdown.Menu>
// 					<Dropdown.Item>
// 						<div className="action client" onClick={() => handleEdit(row._id)}>
// 							<i
// 								className="fa fa-pencil"
// 								style={{
// 									fontSize: 17,
// 									color: '#7c7878',
// 									marginRight: '7px',
// 								}}
// 							></i>
// 							Edit
// 						</div>
// 					</Dropdown.Item>

// 					<Dropdown.Item>
// 						<div
// 							className="action client"
// 							onClick={() => handleDelete(row?._id)}
// 						>
// 							<i
// 								className="fa fa-trash"
// 								style={{
// 									fontSize: 17,
// 									marginRight: '7px',
// 									color: '#7c7878',
// 								}}
// 							></i>
// 							Delete
// 						</div>
// 					</Dropdown.Item>

// 					<Dropdown.Item>
// 						<div
// 							className="action client"
// 							onClick={() => handleBlock(row?._id, row)}
// 						>
// 							<i
// 								className="fa fa-ban"
// 								style={{
// 									fontSize: 17,
// 									marginRight: '7px',
// 									color: '#7c7878',
// 								}}
// 							></i>
// 							Active/Blocked
// 						</div>
// 					</Dropdown.Item>
// 				</Dropdown.Menu>
// 			</Dropdown>
// 		</div>
// 	);
// };
export default AffiliateUserListDataTable;
